import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
}
const _hoisted_2 = {
  key: 1,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LockIcon',
  props: {
  locked: {
    type: Boolean,
    default: true
  },
  classes: {
    type: String,
    default: 'h-4 w-4'
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(__props.classes),
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    (__props.locked)
      ? (_openBlock(), _createElementBlock("path", _hoisted_1))
      : (_openBlock(), _createElementBlock("path", _hoisted_2))
  ], 2))
}
}

})